<template>
  <button @click="emitValue" :disabled="disabled" :class="getButtonStyles">
    <slot>{{ value }}</slot>
    <v-icon right class="mr--2" v-if="isBtnIconVisisble" @click="emitBtnValue">mdi-folder-clock</v-icon>
  </button>
</template>

<script>
export default {
  name: 'bh-button',
  props: {
    btnClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean | Number,
      default: false
    },
    value: {
      type: String,
      default: 'This a button'
    },
    icon: {
      type: String
    },
    isBtnIconVisisble: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getButtonStyles() {
      return this.disabled ? `${this.btnClass} disabled` : `${this.btnClass} pointer`
    }
  },
  methods: {
    emitValue(event) {
      this.$emit('output', event)
    },
    emitBtnValue(evnt) {
      this.$emit('showBtnIcon', event)
    }
  }
}
</script>

<style scoped>
button {
  letter-spacing: -0.0125rem;
  min-width: 6.25rem;
  transition: all 0.2s ease-in-out;
  outline: none;
}
.theme--light.v-icon {
  color: var(--gainsboro-white);
  font-size: 20px;
}
</style>
